import "core-js/modules/es.array.concat.js";
import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import { ThemeContext } from "../../../context/theme.context";
import { StatusMessage } from "../../Messaging/StatusMessage/StatusMessage";
import { Text } from "../../Text/Text/Text";
import Utility from "../../Utility/Utility";
import styles from "./CheckboxInput.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CheckboxInput = function CheckboxInput(_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$statusMessageCla = _ref.statusMessageClassName,
    statusMessageClassName = _ref$statusMessageCla === void 0 ? '' : _ref$statusMessageCla,
    _ref$statusMessageTyp = _ref.statusMessageTypog,
    statusMessageTypog = _ref$statusMessageTyp === void 0 ? 'bodycopySmall' : _ref$statusMessageTyp;
  var theme = useContext(ThemeContext);
  var checkboxID = useRef(Utility.generateUID(''));
  var handler = !disabled ? onChange : undefined;
  var hasError = !!errorMessage;
  var idInput = "checkbox-".concat(name, "-id-").concat(checkboxID.current);
  var idLabel = "checkbox-".concat(name, "-label-id-").concat(checkboxID.current);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames({
      [className]: true,
      [styles.checkboxDarkBackground]: theme === 'darkBackground',
      [styles.checkboxError]: hasError
    }),
    children: [/*#__PURE__*/_jsxs("span", {
      className: styles.checkbox,
      children: [/*#__PURE__*/_jsx("input", {
        "aria-labelledby": idLabel,
        checked: checked,
        className: classnames({
          [styles.input]: true,
          [styles.disabled]: disabled
        }),
        disabled: disabled,
        id: idInput,
        name: name,
        onChange: handler,
        type: "checkbox"
      }), /*#__PURE__*/_jsx("label", {
        id: idLabel,
        className: classnames({
          [styles.label]: true,
          [styles.disabled]: disabled
        }),
        htmlFor: idInput,
        children: /*#__PURE__*/_jsx(Text, {
          richText: true,
          typog: "bodycopySmall",
          children: label
        })
      })]
    }), hasError && /*#__PURE__*/_jsx(StatusMessage, {
      className: statusMessageClassName,
      typog: statusMessageTypog,
      children: errorMessage
    })]
  });
};